/*eslint-disable block-scoped-var, no-redeclare, no-control-regex, no-prototype-builtins, strict*/
"use strict";

var $protobuf = require("protobufjs/light");

var $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.setOptions({
  java_package: "com.foosio.core.responses",
  java_multiple_files: true,
  go_package: "coredata",
  objc_class_prefix: "Proto"
})
.addJSON({
  Achievement: {
    fields: {
      achievementId: {
        type: "string",
        id: 1
      },
      type: {
        type: "Type",
        id: 2
      },
      level: {
        type: "int32",
        id: 3
      },
      value: {
        type: "int64",
        id: 4
      },
      timestamp: {
        type: "int64",
        id: 5
      },
      currentLevelValue: {
        type: "int64",
        id: 6
      },
      currentLevelBonus: {
        type: "Money",
        id: 7
      },
      nextLevelValue: {
        type: "int64",
        id: 8
      },
      nextLevelBonus: {
        type: "Money",
        id: 9
      },
      progress: {
        type: "float",
        id: 10
      },
      progressMin: {
        type: "int64",
        id: 11
      },
      progressMax: {
        type: "int64",
        id: 12
      }
    },
    nested: {
      Type: {
        values: {
          AT_GAMES_PLAYED: 0,
          AT_GAMES_WON: 1,
          AT_CONTEST_WINNINGS: 2,
          AT_CONTEST_WINS: 3,
          AT_MATCH_SCORE: 4,
          AT_BALANCE: 5,
          AT_PLAYER_SCORE: 6,
          AT_LIVE_SUBS: 7,
          AT_FRIENDS: 8,
          AT_FRIEND_REFERRALS: 9,
          AT_FRIEND_GAMES: 10,
          AT_BUNDESLIGA_GAMES: 11,
          AT_BPL_GAMES: 12,
          AT_LALIGA_GAMES: 13,
          AT_SERIEA_GAMES: 14,
          AT_LIGUE1_GAMES: 15,
          AT_ELCL_GAMES: 16,
          AT_NATIONAL_GAMES: 17,
          AT_DAILY_BONUS_STREAK: 18,
          AT_WIN_STREAK: 19
        }
      }
    }
  },
  ArchiveGame: {
    fields: {
      game: {
        type: "Game",
        id: 1
      },
      result: {
        type: "GameResult",
        id: 3
      },
      ownEntry: {
        type: "LeaderboardEntry",
        id: 5
      },
      top: {
        rule: "repeated",
        type: "LeaderboardEntry",
        id: 6
      },
      quiz: {
        rule: "repeated",
        type: "QuizQuestion",
        id: 7
      }
    },
    reserved: [
      [
        2,
        2
      ],
      [
        4,
        4
      ]
    ]
  },
  BonusScoreType: {
    values: {
      BS_UNKNOWN: 0,
      BS_GOAL: 1,
      BS_SHOT_ON_GOAL: 2,
      BS_CORNER: 4,
      BS_TEAM_IN_LEAD_BONUS: 16,
      BS_TEAM_IN_DRAW_BONUS: 17,
      BS_CLEAN_SHEET_BONUS: 18,
      BS_ACTIVITY_BONUS: 19
    }
  },
  ClassicLeaderboardEntry: {
    fields: {
      user: {
        type: "User",
        id: 1
      },
      rank: {
        type: "int32",
        id: 2
      },
      score: {
        type: "int32",
        id: 3
      },
      detail: {
        rule: "repeated",
        type: "Detail",
        id: 4
      }
    },
    nested: {
      Detail: {
        fields: {
          roundTitle: {
            type: "string",
            id: 1
          },
          roundScore: {
            type: "int32",
            id: 2
          }
        }
      }
    }
  },
  Clock: {
    fields: {
      minute: {
        type: "uint32",
        id: 1
      },
      extra: {
        type: "uint32",
        id: 2
      },
      second: {
        type: "uint32",
        id: 3
      }
    }
  },
  Competition: {
    fields: {
      competitionId: {
        type: "string",
        id: 1
      },
      name: {
        type: "string",
        id: 2
      },
      logoUrl: {
        type: "string",
        id: 3
      }
    }
  },
  Contest: {
    fields: {
      contestId: {
        type: "string",
        id: 1
      },
      title: {
        type: "string",
        id: 2
      },
      bannerUrl: {
        type: "string",
        id: 3
      },
      logoUrl: {
        type: "string",
        id: 4
      },
      startTime: {
        type: "int64",
        id: 5
      },
      endTime: {
        type: "int64",
        id: 6
      },
      goal: {
        type: "ContestGoal",
        id: 7
      },
      ownEntry: {
        type: "ContestEntry",
        id: 8
      },
      topPrize: {
        rule: "repeated",
        type: "ContestPrize",
        id: 9
      },
      status: {
        type: "ContestStatus",
        id: 10
      },
      remainingSec: {
        type: "int32",
        id: 11
      },
      autoMmOnly: {
        type: "bool",
        id: 12
      },
      unclaimedPrize: {
        type: "bool",
        id: 13
      },
      entryFee: {
        type: "Money",
        id: 14
      },
      maxParticipants: {
        type: "int32",
        id: 15
      },
      oneTicketPerMatch: {
        type: "bool",
        id: 16
      }
    }
  },
  ContestStatus: {
    values: {
      CS_UPCOMING: 0,
      CS_LIVE: 1,
      CS_OVER: 2
    }
  },
  ContestEntry: {
    fields: {
      user: {
        type: "User",
        id: 1
      },
      rank: {
        type: "int32",
        id: 2
      },
      score: {
        type: "int32",
        id: 3
      },
      rankDelta: {
        type: "sint32",
        id: 4
      },
      prize: {
        rule: "repeated",
        type: "ContestPrize",
        id: 5
      },
      details: {
        rule: "repeated",
        type: "ContestScoreDetails",
        id: 6
      }
    }
  },
  ContestScoreDetails: {
    fields: {
      match: {
        type: "Match",
        id: 1
      },
      score: {
        type: "int32",
        id: 2
      },
      live: {
        type: "bool",
        id: 3
      }
    }
  },
  ContestGoal: {
    fields: {
      type: {
        type: "Type",
        id: 1
      },
      x: {
        type: "int32",
        id: 2
      }
    },
    nested: {
      Type: {
        values: {
          CGT_TOP_SCORE: 0,
          CGT_TOTAL_SCORE_BEST_X: 1,
          CGT_TOTAL_WINNINGS: 2,
          CGT_TOTAL_GAMES: 3,
          CGT_TOTAL_WINS: 4
        }
      }
    }
  },
  ContestPrize: {
    oneofs: {
      prizeType: {
        oneof: [
          "money",
          "product"
        ]
      }
    },
    fields: {
      money: {
        type: "Money",
        id: 1
      },
      product: {
        type: "PrizeProduct",
        id: 2
      }
    }
  },
  PrizeProduct: {
    fields: {
      title: {
        type: "string",
        id: 1
      },
      imageUrl: {
        type: "string",
        id: 2
      },
      thumbnailUrl: {
        type: "string",
        id: 3
      },
      quantity: {
        type: "int32",
        id: 4
      }
    }
  },
  PrizePoolEntry: {
    fields: {
      fromRank: {
        type: "int32",
        id: 1
      },
      toRank: {
        type: "int32",
        id: 2
      },
      prize: {
        rule: "repeated",
        type: "ContestPrize",
        id: 3
      }
    }
  },
  Currency: {
    values: {
      CR_UNKNOWN: 0,
      CR_VIRTUAL: 1,
      CR_EUR_CENT: 2,
      CR_USD_CENT: 3,
      CR_GBP_CENT: 4,
      CR_HUF: 5,
      CR_JPY: 6
    }
  },
  Game: {
    oneofs: {
      progressContent: {
        oneof: [
          "progressLineups",
          "progressStatus",
          "progressNotPlaying",
          "progressInviteFrom",
          "progressInviteAccepted",
          "progressFinishTime",
          "progressClassic"
        ]
      }
    },
    fields: {
      gameId: {
        type: "string",
        id: 1
      },
      type: {
        type: "GameType",
        id: 2
      },
      size: {
        type: "int32",
        id: 3
      },
      startTime: {
        type: "int64",
        id: 4
      },
      match: {
        type: "Match",
        id: 6
      },
      pot: {
        type: "Money",
        id: 7
      },
      invitation: {
        type: "bool",
        id: 9
      },
      maxPot: {
        type: "Money",
        id: 12
      },
      entryFee: {
        type: "Money",
        id: 13
      },
      finishTime: {
        type: "int64",
        id: 14
      },
      outcome: {
        type: "GameOutcome",
        id: 16
      },
      ownEntry: {
        type: "LeaderboardEntry",
        id: 17
      },
      host: {
        type: "User",
        id: 18
      },
      invitedCount: {
        type: "int32",
        id: 19
      },
      acceptedCount: {
        type: "int32",
        id: 20
      },
      progress: {
        type: "float",
        id: 21
      },
      progressColor: {
        type: "ProgressColor",
        id: 22
      },
      progressLineups: {
        type: "bool",
        id: 23
      },
      progressStatus: {
        type: "MatchStatusSummary",
        id: 24
      },
      progressNotPlaying: {
        type: "int32",
        id: 25
      },
      progressInviteFrom: {
        type: "User",
        id: 26
      },
      progressInviteAccepted: {
        type: "int32",
        id: 27
      },
      progressFinishTime: {
        type: "int64",
        id: 28
      },
      progressClassic: {
        type: "ClassicProgress",
        id: 33
      },
      health: {
        type: "GameHealth",
        id: 30
      },
      inContest: {
        type: "bool",
        id: 31
      },
      activeQuiz: {
        type: "QuizSection",
        id: 32
      },
      classicGameInfo: {
        type: "ClassicGameInfo",
        id: 34
      }
    },
    reserved: [
      [
        5,
        5
      ],
      [
        8,
        8
      ],
      [
        10,
        10
      ],
      [
        11,
        11
      ],
      [
        15,
        15
      ],
      [
        29,
        29
      ]
    ],
    nested: {
      ProgressColor: {
        values: {
          GPC_INACTIVE: 0,
          GPC_ACTIVE: 1,
          GPC_WARNING: 2,
          GPC_INVITE: 3
        }
      },
      ClassicProgress: {
        fields: {
          progressPart: {
            rule: "repeated",
            type: "ProgressPart",
            id: 1
          },
          matchCount: {
            type: "int32",
            id: 2
          },
          matchesStarted: {
            type: "int32",
            id: 3
          }
        }
      },
      ProgressPart: {
        fields: {
          progress: {
            type: "float",
            id: 1
          },
          status: {
            type: "MatchStatus",
            id: 2
          }
        }
      },
      ClassicGameInfo: {
        fields: {
          competition: {
            type: "Competition",
            id: 1
          },
          round: {
            type: "TournamentRound",
            id: 2
          },
          status: {
            type: "MatchStatus",
            id: 3
          }
        }
      }
    }
  },
  MatchStatusSummary: {
    fields: {
      status: {
        type: "MatchStatus",
        id: 1
      },
      period: {
        type: "MatchPeriod",
        id: 2
      },
      clock: {
        type: "Clock",
        id: 3
      },
      health: {
        type: "GameHealth",
        id: 4
      }
    }
  },
  GameResult: {
    fields: {
      rank: {
        type: "int32",
        id: 1
      },
      score: {
        type: "int32",
        id: 2
      },
      prize: {
        type: "Money",
        id: 3
      },
      acknowledged: {
        type: "bool",
        id: 6
      }
    },
    reserved: [
      [
        5,
        5
      ],
      [
        4,
        4
      ]
    ]
  },
  GameOutcome: {
    values: {
      GO_NONE: 0,
      GO_WON: 1,
      GO_LOST: 2,
      GO_CANCELLED: 3,
      GO_REFUNDED: 4,
      GO_SOLO: 5
    }
  },
  GameHealth: {
    values: {
      GH_OK: 0,
      GH_INTERNAL_ERROR: 1,
      GH_INTERRUPTED: 2,
      GH_POSTPONED: 3
    }
  },
  GameType: {
    values: {
      GT_UNKNOWN: 0,
      GT_AUTO_MM: 1,
      GT_PRIVATE: 2,
      GT_PUBLIC: 3,
      GT_CLASSIC: 4
    }
  },
  GlobalLeaderboardEntry: {
    fields: {
      user: {
        type: "User",
        id: 1
      },
      match: {
        type: "Match",
        id: 2
      },
      rank: {
        type: "int32",
        id: 3
      },
      score: {
        type: "int32",
        id: 4
      },
      winnings: {
        type: "Money",
        id: 5
      }
    }
  },
  Interval: {
    fields: {
      start: {
        type: "uint32",
        id: 1
      },
      end: {
        type: "uint32",
        id: 2
      }
    }
  },
  Jersey: {
    fields: {
      jerseyNumber: {
        type: "string",
        id: 1
      },
      baseColor: {
        type: "string",
        id: 2
      },
      sleeveColor: {
        type: "string",
        id: 3
      },
      numberColor: {
        type: "string",
        id: 4
      }
    },
    reserved: [
      [
        5,
        5
      ],
      [
        6,
        6
      ]
    ]
  },
  LeaderboardEntry: {
    fields: {
      rank: {
        type: "int32",
        id: 1
      },
      user: {
        type: "User",
        id: 2
      },
      score: {
        type: "int32",
        id: 3
      },
      currentPrize: {
        type: "Money",
        id: 4
      },
      team: {
        rule: "repeated",
        type: "Player",
        id: 5
      },
      ticketId: {
        type: "string",
        id: 7
      },
      pending: {
        type: "bool",
        id: 8
      },
      host: {
        type: "bool",
        id: 9
      },
      rankDelta: {
        type: "sint32",
        id: 10
      },
      previous: {
        rule: "repeated",
        type: "Player",
        id: 11
      },
      bonus: {
        rule: "repeated",
        type: "BonusScore",
        id: 13
      }
    },
    reserved: [
      [
        6,
        6
      ],
      [
        12,
        12
      ]
    ],
    nested: {
      BonusScore: {
        fields: {
          bonusType: {
            type: "string",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          subtitle: {
            type: "string",
            id: 3
          },
          iconUrl: {
            type: "string",
            id: 4
          },
          score: {
            type: "int32",
            id: 5
          }
        }
      }
    }
  },
  Match: {
    fields: {
      matchId: {
        type: "string",
        id: 1
      },
      kickoff: {
        type: "int64",
        id: 2
      },
      competition: {
        type: "Competition",
        id: 3
      },
      homeTeam: {
        type: "Team",
        id: 4
      },
      awayTeam: {
        type: "Team",
        id: 5
      },
      clock: {
        type: "Clock",
        id: 6
      },
      period: {
        type: "MatchPeriod",
        id: 8
      },
      status: {
        type: "MatchStatus",
        id: 9
      },
      halfTimeScore: {
        type: "string",
        id: 12
      },
      fullTimeScore: {
        type: "string",
        id: 13
      },
      extraTimeScore: {
        type: "string",
        id: 14
      },
      currentScore: {
        type: "string",
        id: 15
      },
      kickoffRemainingSec: {
        type: "int32",
        id: 16
      },
      lineupAvailable: {
        type: "bool",
        id: 17
      },
      tournamentRound: {
        type: "TournamentRound",
        id: 18
      },
      betOffer: {
        type: "BetOffer",
        id: 19
      }
    },
    reserved: [
      [
        7,
        7
      ],
      [
        10,
        10
      ],
      [
        11,
        11
      ]
    ]
  },
  SponsoredMatch: {
    fields: {
      match: {
        type: "Match",
        id: 1
      }
    }
  },
  TournamentRound: {
    fields: {
      type: {
        type: "string",
        id: 1
      },
      name: {
        type: "string",
        id: 2
      },
      number: {
        type: "int64",
        id: 3
      },
      cupRoundMatches: {
        type: "int64",
        id: 4
      },
      cupRoundMatchNumber: {
        type: "int64",
        id: 5
      }
    }
  },
  BetOffer: {
    fields: {
      providerId: {
        type: "string",
        id: 1
      },
      providerLogo: {
        type: "string",
        id: 2
      },
      home: {
        type: "Market",
        id: 3
      },
      draw: {
        type: "Market",
        id: 4
      },
      away: {
        type: "Market",
        id: 5
      }
    },
    nested: {
      Market: {
        fields: {
          odd: {
            type: "string",
            id: 1
          },
          url: {
            type: "string",
            id: 2
          }
        }
      }
    }
  },
  MatchEvent: {
    fields: {
      eventId: {
        type: "string",
        id: 1
      },
      teamId: {
        type: "string",
        id: 2
      },
      playerId: {
        type: "string",
        id: 3
      },
      type: {
        type: "MatchEventType",
        id: 4
      },
      clock: {
        type: "Clock",
        id: 5
      },
      displayValue: {
        type: "sint32",
        id: 13
      },
      timestamp: {
        type: "int64",
        id: 14
      },
      elapsedMin: {
        type: "int32",
        id: 15
      }
    },
    reserved: [
      [
        7,
        7
      ],
      [
        8,
        8
      ],
      [
        9,
        9
      ],
      [
        10,
        10
      ],
      [
        11,
        11
      ],
      [
        6,
        6
      ]
    ]
  },
  MatchEventType: {
    values: {
      ET_UNKNOWN: 0,
      ET_GOAL: 1,
      ET_SHOT_ON_GOAL: 2,
      ET_OWN_GOAL: 3,
      ET_CORNER: 4,
      ET_ASSIST: 5,
      ET_YELLOW_CARD: 6,
      ET_YELLOW_RED_CARD: 7,
      ET_RED_CARD: 8,
      ET_PENALTY_GOAL: 9,
      ET_PENALTY_MISSED: 10,
      ET_PENALTY_SAVED: 11,
      ET_PENALTY_SHOOTOUT_GOAL: 12,
      ET_PENALTY_SHOOTOUT_MISSED: 13,
      ET_SUB_IN: 14,
      ET_SUB_OUT: 15,
      ET_SAVE: 16,
      ET_PENALTY_CONCEDED: 17,
      ET_ADM_MATCH_STARTED: 18,
      ET_ADM_MATCH_FINISHED: 19,
      ET_ADM_HALF_TIME_STARTED: 20,
      ET_ADM_SECOND_HALF_STARTED: 21,
      ET_ADM_FULL_TIME: 22,
      ET_ADM_EXTRA_HALF_1_STARTED: 23,
      ET_ADM_EXTRA_TIME_BREAK_STARTED: 24,
      ET_ADM_EXTRA_HALF_2_STARTED: 25,
      ET_ADM_WAITING_FOR_PENALTY_SHOOTOUT: 26,
      ET_ADM_PENALTY_SHOOTOUT_STARTED: 27
    }
  },
  MatchPeriod: {
    values: {
      MP_UNKNOWN: 0,
      MP_FIRST_HALF: 1,
      MP_SECOND_HALF: 2,
      MP_HALF_TIME: 3,
      MP_EXTRA_TIME_1: 4,
      MP_EXTRA_TIME_2: 5,
      MP_EXTRA_TIME_BREAK: 6,
      MP_PENALTY_SHOOTOUT: 7,
      MP_FULL_TIME: 8
    }
  },
  MatchStatus: {
    values: {
      MS_UNKNOWN: 0,
      MS_UPCOMING: 1,
      MS_LIVE: 2,
      MS_FINISHED: 3,
      MS_CANCELLED: 5
    }
  },
  Money: {
    fields: {
      value: {
        type: "int64",
        id: 1
      },
      currency: {
        type: "Currency",
        id: 2
      }
    }
  },
  NotificationType: {
    fields: {
      notificationId: {
        type: "string",
        id: 1
      },
      title: {
        type: "string",
        id: 2
      },
      enabled: {
        type: "bool",
        id: 3
      },
      available: {
        type: "bool",
        id: 4
      }
    }
  },
  Player: {
    fields: {
      playerId: {
        type: "string",
        id: 1
      },
      name: {
        type: "string",
        id: 2
      },
      photoUrl: {
        type: "string",
        id: 3
      },
      jersey: {
        type: "Jersey",
        id: 4
      },
      team: {
        type: "Team",
        id: 5
      },
      cost: {
        type: "int32",
        id: 6
      },
      currentScore: {
        type: "int32",
        id: 7
      },
      status: {
        type: "PlayerStatus",
        id: 8
      },
      averageScore: {
        type: "double",
        id: 9
      },
      position: {
        type: "PlayerPosition",
        id: 12
      },
      suggested: {
        type: "bool",
        id: 13
      },
      missingReason: {
        type: "MissingReason",
        id: 14
      },
      matchSubIn: {
        type: "Clock",
        id: 17
      },
      matchSubOut: {
        type: "Clock",
        id: 18
      },
      fullName: {
        type: "string",
        id: 19
      },
      lastSubTime: {
        type: "Clock",
        id: 20
      },
      lastSubAuto: {
        type: "bool",
        id: 21
      },
      popularity: {
        type: "int32",
        id: 22
      },
      inTeam: {
        type: "bool",
        id: 23
      },
      notPlaying: {
        type: "bool",
        id: 24
      },
      largePhotoUrl: {
        type: "string",
        id: 27
      },
      previousMatchScore: {
        type: "int32",
        id: 28
      },
      averageMinutesPlayed: {
        type: "int32",
        id: 29
      },
      averageScorePerMinute: {
        type: "double",
        id: 30
      },
      substitutionEnabled: {
        type: "bool",
        id: 31
      }
    },
    reserved: [
      [
        10,
        10
      ],
      [
        11,
        11
      ],
      [
        15,
        15
      ],
      [
        16,
        16
      ],
      [
        25,
        25
      ],
      [
        26,
        26
      ]
    ],
    nested: {
      MissingReason: {
        values: {
          PMR_NONE: 0,
          PMR_OTHER: 1,
          PMR_INJURY: 2,
          PMR_SUSPENSION: 3
        }
      }
    }
  },
  PlayerPosition: {
    values: {
      PP_UNKNOWN: 0,
      PP_ATTACKER: 1,
      PP_MIDFIELDER: 2,
      PP_DEFENDER: 3,
      PP_GOALKEEPER: 4
    }
  },
  PlayerStatus: {
    values: {
      PS_UNKNOWN: 0,
      PS_ACTIVE: 1,
      PS_INACTIVE: 2,
      PS_LEFTOUT: 3,
      PS_SENTOFF: 4,
      PS_FINISHED: 5
    }
  },
  QuizQuestion: {
    fields: {
      questionId: {
        type: "string",
        id: 1
      },
      title: {
        type: "string",
        id: 2
      },
      subtitle: {
        type: "string",
        id: 3
      },
      answer: {
        rule: "repeated",
        type: "QuizAnswer",
        id: 4
      },
      selectedAnswerId: {
        type: "string",
        id: 5
      },
      correctAnswerId: {
        type: "string",
        id: 6
      },
      editable: {
        type: "bool",
        id: 7
      },
      outcome: {
        type: "Outcome",
        id: 8
      },
      iconUrl: {
        type: "string",
        id: 9
      }
    },
    nested: {
      Outcome: {
        values: {
          QQ_UNKNOWN: 0,
          QQ_CORRECT: 1,
          QQ_INCORRECT: 2,
          QQ_UNANSWERED: 3
        }
      }
    }
  },
  QuizAnswer: {
    fields: {
      answerId: {
        type: "string",
        id: 1
      },
      shortText: {
        type: "string",
        id: 2
      },
      longText: {
        type: "string",
        id: 3
      }
    },
    reserved: [
      [
        4,
        4
      ]
    ]
  },
  QuizSection: {
    fields: {
      title: {
        type: "string",
        id: 1
      },
      question: {
        rule: "repeated",
        type: "QuizQuestion",
        id: 2
      },
      iconUrl: {
        type: "string",
        id: 3
      }
    }
  },
  Referral: {
    fields: {
      user: {
        type: "User",
        id: 1
      },
      nextRemaining: {
        type: "int32",
        id: 2
      },
      nextBonus: {
        type: "Money",
        id: 3
      },
      timestamp: {
        type: "int64",
        id: 4
      }
    }
  },
  ReferralBonus: {
    fields: {
      type: {
        type: "Type",
        id: 1
      },
      value: {
        type: "Money",
        id: 2
      },
      referral: {
        rule: "repeated",
        type: "Referral",
        id: 3
      },
      receivedBonus: {
        type: "Money",
        id: 4
      }
    },
    nested: {
      Type: {
        values: {
          RBT_REGISTRATION: 0,
          RBT_MATCHES_10: 1,
          RBT_MATCHES_100: 2,
          RBT_PURCHASE: 3
        }
      }
    }
  },
  RuleItem: {
    oneofs: {
      itemType: {
        oneof: [
          "event",
          "bonus"
        ]
      }
    },
    fields: {
      event: {
        type: "MatchEventType",
        id: 1
      },
      bonus: {
        type: "BonusScoreType",
        id: 2
      },
      personalValue: {
        type: "int32",
        id: 3
      },
      teamValue: {
        type: "int32",
        id: 4
      }
    }
  },
  ScoringItem: {
    oneofs: {
      itemType: {
        oneof: [
          "event",
          "bonus"
        ]
      }
    },
    fields: {
      event: {
        type: "MatchEventType",
        id: 1
      },
      bonus: {
        type: "BonusScoreType",
        id: 2
      },
      count: {
        type: "int32",
        id: 3
      },
      value: {
        type: "int32",
        id: 4
      },
      totalCount: {
        type: "int32",
        id: 5
      },
      totalValue: {
        type: "int32",
        id: 6
      }
    }
  },
  StoreProduct: {
    fields: {
      productId: {
        type: "string",
        id: 1
      },
      quantity: {
        type: "int32",
        id: 2
      },
      price: {
        rule: "repeated",
        type: "Money",
        id: 3
      },
      type: {
        type: "Type",
        id: 8
      },
      level: {
        type: "int32",
        id: 9
      }
    },
    reserved: [
      [
        4,
        4
      ],
      [
        5,
        5
      ],
      [
        6,
        6
      ],
      [
        7,
        7
      ]
    ],
    nested: {
      Type: {
        values: {
          COIN: 0,
          AUTOSUB: 1
        }
      }
    }
  },
  StorePremiumProduct: {
    fields: {
      productId: {
        type: "string",
        id: 1
      },
      type: {
        type: "Type",
        id: 2
      },
      price: {
        rule: "repeated",
        type: "Money",
        id: 3
      },
      duration: {
        type: "int32",
        id: 4
      },
      title: {
        type: "string",
        id: 5
      },
      summary: {
        type: "string",
        id: 6
      },
      detail: {
        rule: "repeated",
        type: "string",
        id: 7,
        options: {
          deprecated: true
        }
      },
      detailItem: {
        rule: "repeated",
        type: "DetailItem",
        id: 8
      }
    },
    nested: {
      Type: {
        values: {
          SILVER: 0,
          GOLD: 1
        }
      },
      DetailItem: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          detail: {
            type: "string",
            id: 2
          }
        }
      }
    }
  },
  Team: {
    fields: {
      teamId: {
        type: "string",
        id: 1
      },
      name: {
        type: "string",
        id: 2
      },
      tlaName: {
        type: "string",
        id: 3
      },
      logoUrl: {
        type: "string",
        id: 4
      },
      jersey: {
        type: "Jersey",
        id: 5
      }
    }
  },
  User: {
    fields: {
      userId: {
        type: "string",
        id: 1
      },
      name: {
        type: "string",
        id: 2
      },
      photoUrl: {
        type: "string",
        id: 3
      },
      totalScore: {
        type: "int32",
        id: 5
      },
      balance: {
        rule: "repeated",
        type: "Money",
        id: 7
      },
      relationship: {
        type: "UserRelationship",
        id: 8
      },
      facebookFriend: {
        type: "bool",
        id: 9
      },
      gamesCount: {
        type: "int32",
        id: 10
      }
    },
    reserved: [
      [
        4,
        4
      ],
      [
        6,
        6
      ]
    ]
  },
  UserRelationship: {
    values: {
      UR_NONE: 0,
      UR_OUTGOING: 1,
      UR_INCOMING: 2,
      UR_MUTUAL: 3
    }
  },
  ActivateAutosubResponse: {
    fields: {
      result: {
        type: "Result",
        id: 1
      }
    },
    nested: {
      Result: {
        values: {
          AAR_UNKNOWN_ERROR: 0,
          AAR_SUCCESS: 1,
          AAR_INSUFFICIENT_AUTOSUBS: 2,
          AAR_AUTOSUB_UNAVAILABLE: 3
        }
      }
    }
  },
  AndroidPurchaseResponse: {
    fields: {
      result: {
        type: "Result",
        id: 1
      }
    },
    nested: {
      Result: {
        values: {
          APR_UNKNOWN_ERROR: 0,
          APR_SUCCESS: 1,
          APR_ALREADY_CONSUMED: 2,
          APR_CANCELLED: 3
        }
      }
    }
  },
  BraintreePurchaseResponse: {
    fields: {
      transactionId: {
        type: "string",
        id: 2
      },
      status: {
        type: "string",
        id: 3
      },
      complete: {
        type: "bool",
        id: 4
      },
      success: {
        type: "bool",
        id: 5
      }
    },
    reserved: [
      [
        1,
        1
      ]
    ]
  },
  BraintreeTokenResponse: {
    fields: {
      token: {
        type: "string",
        id: 1
      }
    }
  },
  ClaimBonusResponse: {
    fields: {
      result: {
        type: "Result",
        id: 1
      },
      bonusReceived: {
        type: "Money",
        id: 2
      },
      newBalance: {
        type: "Money",
        id: 3
      }
    },
    nested: {
      Result: {
        values: {
          CBR_UNKNOWN_ERROR: 0,
          CBR_SUCCESS: 1,
          CBR_NOT_ELIGIBLE: 2
        }
      }
    }
  },
  ClaimContestPrizeResponse: {
    fields: {
      result: {
        type: "Result",
        id: 1
      },
      prize: {
        rule: "repeated",
        type: "ContestPrize",
        id: 2
      },
      newBalance: {
        type: "Money",
        id: 3
      }
    },
    nested: {
      Result: {
        values: {
          CCPR_UNKNOWN_ERROR: 0,
          CCPR_SUCCESS: 1,
          CCPR_NOT_ELIGIBLE: 2,
          CCPR_INVALID_EMAIL: 3
        }
      }
    }
  },
  ClaimPromotionResponse: {
    fields: {
      dialogTitle: {
        type: "string",
        id: 1
      },
      dialogMessage: {
        type: "string",
        id: 2
      },
      couponTitle: {
        type: "string",
        id: 3
      },
      couponCode: {
        type: "string",
        id: 4
      },
      couponMessage: {
        type: "string",
        id: 5
      },
      couponCta: {
        type: "string",
        id: 6
      },
      couponUrl: {
        type: "string",
        id: 7
      },
      result: {
        type: "Result",
        id: 100
      },
      errorTitle: {
        type: "string",
        id: 101
      },
      errorMessage: {
        type: "string",
        id: 102
      }
    },
    nested: {
      Result: {
        values: {
          CPR_UNKNOWN_ERROR: 0,
          CPR_SUCCESS: 1
        }
      }
    }
  },
  ClassicGamesResponse: {
    fields: {
      entryFee: {
        type: "Money",
        id: 1
      },
      game: {
        rule: "repeated",
        type: "ClassicGame",
        id: 2
      },
      info: {
        type: "Info",
        id: 3
      }
    },
    nested: {
      ClassicGame: {
        fields: {
          id: {
            type: "string",
            id: 1
          },
          competition: {
            type: "Competition",
            id: 2
          },
          round: {
            type: "TournamentRound",
            id: 3
          },
          nextStart: {
            type: "int64",
            id: 4
          },
          userCount: {
            type: "int32",
            id: 5
          },
          firstPrize: {
            type: "Money",
            id: 6
          }
        }
      },
      Info: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          rule: {
            rule: "repeated",
            type: "string",
            id: 2
          }
        }
      }
    }
  },
  ClassicLeaderboardResponse: {
    fields: {
      leaderboard: {
        rule: "repeated",
        type: "ClassicLeaderboardEntry",
        id: 1
      },
      ownEntry: {
        type: "ClassicLeaderboardEntry",
        id: 2
      },
      competition: {
        rule: "repeated",
        type: "Competition",
        id: 3
      },
      selectedCompetition: {
        type: "Competition",
        id: 4
      }
    }
  },
  ClassicPlayersResponse: {
    fields: {
      group: {
        rule: "repeated",
        type: "Group",
        id: 1
      }
    },
    nested: {
      Group: {
        fields: {
          match: {
            type: "Match",
            id: 1
          },
          player: {
            rule: "repeated",
            type: "Player",
            id: 2
          }
        }
      }
    }
  },
  ContestDetailsResponse: {
    fields: {
      contest: {
        type: "Contest",
        id: 1
      },
      leaderboard: {
        rule: "repeated",
        type: "ContestEntry",
        id: 2
      },
      competition: {
        rule: "repeated",
        type: "Competition",
        id: 4
      },
      team: {
        rule: "repeated",
        type: "Team",
        id: 5
      },
      match: {
        rule: "repeated",
        type: "Match",
        id: 6
      },
      prizePool: {
        rule: "repeated",
        type: "PrizePoolEntry",
        id: 7
      },
      matchesAvailable: {
        type: "bool",
        id: 8
      }
    },
    reserved: [
      [
        3,
        3
      ]
    ]
  },
  ContestsResponse: {
    fields: {
      contest: {
        rule: "repeated",
        type: "Contest",
        id: 1
      },
      introAcked: {
        type: "bool",
        id: 2
      }
    }
  },
  CreateGameResponse: {
    fields: {
      result: {
        type: "Result",
        id: 1
      },
      gameId: {
        type: "string",
        id: 2
      }
    },
    nested: {
      Result: {
        values: {
          CGR_UNKNOWN_ERROR: 0,
          CGR_SUCCESS: 1,
          CGR_INSUFFICIENT_BALANCE: 2,
          CGR_INVALID_TYPE: 4,
          CGR_INVALID_MATCH: 6,
          CGR_EXPIRED_MATCH: 7,
          CGR_INVITATION_LIMIT_EXCEEDED: 8,
          CGR_INVALID_ENTRY_FEE: 9,
          CGR_INVALID_PLAYER_ID: 10,
          CGR_INSUFFICIENT_BUDGET: 11,
          CGR_SAVE_UNAVAILABLE: 12,
          CGR_GOALKEEPER_LIMIT_EXCEEDED: 13,
          CGR_INSUFFICIENT_AUTOSUBS: 14,
          CGR_ALREADY_JOINED: 15
        }
      }
    }
  },
  EditInvitationResponse: {
    fields: {
      result: {
        type: "Result",
        id: 1
      }
    },
    nested: {
      Result: {
        values: {
          EIR_UNKNOWN_ERROR: 0,
          EIR_SUCCESS: 1,
          EIR_INVITATION_EXPIRED: 2,
          EIR_INSUFFICIENT_BALANCE: 3,
          EIR_ALREADY_ACCEPTED: 4,
          ETR_INVALID_PLAYER_ID: 5,
          ETR_INSUFFICIENT_BUDGET: 6,
          ETR_SAVE_UNAVAILABLE: 7,
          ETR_GOALKEEPER_LIMIT_EXCEEDED: 8
        }
      }
    }
  },
  EditProfileResponse: {
    fields: {
      result: {
        type: "Result",
        id: 1
      }
    },
    nested: {
      Result: {
        values: {
          EPR_UNKNOWN_ERROR: 0,
          EPR_SUCCESS: 1,
          EPR_INVALID_NAME: 2,
          EPR_INVALID_PHOTO: 3,
          EPR_INVALID_DATE_OF_BIRTH: 4,
          EPR_MISSING_FIELDS: 5
        }
      }
    }
  },
  FriendsResponse: {
    fields: {
      friend: {
        rule: "repeated",
        type: "User",
        id: 1
      },
      request: {
        rule: "repeated",
        type: "User",
        id: 2
      },
      facebookStatus: {
        type: "FacebookStatus",
        id: 3
      },
      facebookCount: {
        type: "int32",
        id: 4
      }
    },
    nested: {
      FacebookStatus: {
        values: {
          FBS_NO_TOKEN: 0,
          FBS_INVALID_TOKEN: 1,
          FBS_INSUFFICIENT_SCOPE: 2,
          FBS_SUCCESS: 3
        }
      }
    }
  },
  GameDetailsResponse: {
    fields: {
      game: {
        type: "Game",
        id: 1
      },
      result: {
        type: "GameResult",
        id: 4
      },
      leaderboard: {
        rule: "repeated",
        type: "LeaderboardEntry",
        id: 5
      },
      acknowledged: {
        type: "bool",
        id: 7
      },
      timeline: {
        type: "MatchDetailsResponse",
        id: 8
      },
      inviteEnabled: {
        type: "bool",
        id: 10
      },
      autosubEnabled: {
        type: "bool",
        id: 12
      },
      autosubAvailable: {
        type: "bool",
        id: 13
      },
      substitutionEnabled: {
        type: "bool",
        id: 14,
        options: {
          deprecated: true
        }
      },
      quiz: {
        rule: "repeated",
        type: "QuizSection",
        id: 15
      },
      quizOutcomeImageUrl: {
        type: "string",
        id: 16
      },
      quizOutcomeTitle: {
        type: "string",
        id: 17
      },
      quizOutcomeMessage: {
        type: "string",
        id: 18
      },
      chatPath: {
        type: "string",
        id: 19
      },
      classicMatch: {
        rule: "repeated",
        type: "Match",
        id: 20
      },
      shareCta: {
        type: "string",
        id: 21
      },
      shareMessage: {
        type: "string",
        id: 22
      }
    },
    reserved: [
      [
        2,
        3
      ],
      [
        9,
        9
      ],
      [
        11,
        11
      ],
      [
        6,
        6
      ]
    ]
  },
  GameHistoryResponse: {
    fields: {
      game: {
        rule: "repeated",
        type: "ArchiveGame",
        id: 1
      },
      unackedGame: {
        rule: "repeated",
        type: "ArchiveGame",
        id: 3
      }
    },
    reserved: [
      [
        2,
        2
      ]
    ]
  },
  GamePrizeInfoResponse: {
    fields: {
      feeOption: {
        rule: "repeated",
        type: "FeeOption",
        id: 8
      },
      defaultFeeOptionIndex: {
        type: "int32",
        id: 9
      }
    },
    reserved: [
      [
        1,
        7
      ]
    ],
    nested: {
      FeeOption: {
        fields: {
          entryFee: {
            type: "Money",
            id: 1
          },
          maxPot: {
            type: "Money",
            id: 2
          },
          joins: {
            type: "int64",
            id: 3,
            options: {
              deprecated: true
            }
          },
          highlight: {
            type: "Highlight",
            id: 4
          }
        }
      },
      Highlight: {
        values: {
          FOH_NONE: 0,
          FOH_TOP: 1
        }
      }
    }
  },
  GamesResponse: {
    fields: {
      game: {
        rule: "repeated",
        type: "Game",
        id: 3
      },
      sponsored: {
        type: "SponsoredMatch",
        id: 7
      }
    },
    reserved: [
      [
        1,
        1
      ],
      [
        2,
        2
      ],
      [
        4,
        4
      ],
      [
        5,
        5
      ],
      [
        6,
        6
      ]
    ]
  },
  GeneralResponse: {
    fields: {
      result: {
        type: "Result",
        id: 1
      }
    },
    nested: {
      Result: {
        values: {
          GR_UNKNOWN_ERROR: 0,
          GR_SUCCESS: 1
        }
      }
    }
  },
  GlobalLeaderboardResponse: {
    fields: {
      leaderboard: {
        rule: "repeated",
        type: "GlobalLeaderboardEntry",
        id: 1
      },
      ownEntry: {
        type: "GlobalLeaderboardEntry",
        id: 2
      }
    }
  },
  IOSPurchaseResponse: {
    fields: {
      transactionId: {
        rule: "repeated",
        type: "string",
        id: 1
      },
      result: {
        type: "Result",
        id: 2
      }
    },
    nested: {
      Result: {
        values: {
          IPR_UNKNOWN_ERROR: 0,
          IPR_SUCCESS: 1
        }
      }
    }
  },
  KickerLoginResponse: {
    fields: {
      token: {
        type: "string",
        id: 1
      },
      error: {
        type: "string",
        id: 2
      }
    }
  },
  LoginResponse: {
    fields: {
      result: {
        type: "Result",
        id: 1
      },
      newUser: {
        type: "bool",
        id: 2
      },
      rules: {
        type: "Rules",
        id: 5
      },
      fantaplanetAgreement: {
        type: "FPAgreementStatus",
        id: 9
      }
    },
    reserved: [
      [
        3,
        3
      ],
      [
        4,
        4
      ],
      [
        6,
        6
      ],
      [
        7,
        7
      ],
      [
        8,
        8
      ]
    ],
    nested: {
      Result: {
        values: {
          LR_UNKNOWN_ERROR: 0,
          LR_SUCCESS: 1,
          LR_OUTDATED_CLIENT: 2
        }
      },
      Rules: {
        fields: {
          maxTeamBudget: {
            type: "int32",
            id: 1
          },
          minTeamPlayers: {
            type: "int32",
            id: 2
          },
          maxPrivateInvitations: {
            type: "int32",
            id: 3
          },
          matchJoinWindowMinutes: {
            type: "int32",
            id: 4
          },
          validEntryFee: {
            rule: "repeated",
            type: "int32",
            id: 5
          },
          defaultEntryFeeIndex: {
            type: "int32",
            id: 6
          }
        }
      },
      FPAgreementStatus: {
        values: {
          FPA_OK: 0,
          FPA_AGREEMENT_NEEDED_ADULT: 1,
          FPA_AGREEMENT_NEEDED_UNDERAGE: 2
        }
      }
    }
  },
  MatchDetailsResponse: {
    fields: {
      match: {
        type: "Match",
        id: 1
      },
      event: {
        rule: "repeated",
        type: "MatchEvent",
        id: 2
      },
      player: {
        keyType: "string",
        type: "Player",
        id: 3
      },
      trending: {
        rule: "repeated",
        type: "Player",
        id: 4
      }
    }
  },
  MatchesResponse: {
    fields: {
      date: {
        rule: "repeated",
        type: "DateGroup",
        id: 3
      },
      sponsored: {
        type: "SponsoredMatch",
        id: 4
      }
    },
    reserved: [
      [
        1,
        1
      ],
      [
        2,
        2
      ]
    ],
    nested: {
      DateGroup: {
        fields: {
          date: {
            type: "int64",
            id: 1
          },
          competition: {
            rule: "repeated",
            type: "CompetitionGroup",
            id: 2
          }
        }
      },
      CompetitionGroup: {
        fields: {
          competition: {
            type: "Competition",
            id: 1
          },
          match: {
            rule: "repeated",
            type: "Match",
            id: 2
          }
        }
      }
    }
  },
  NotificationSettingsResponse: {
    fields: {
      notification: {
        rule: "repeated",
        type: "NotificationType",
        id: 7
      },
      upgradeAvailable: {
        type: "bool",
        id: 8
      }
    },
    reserved: [
      [
        1,
        6
      ]
    ]
  },
  PlayerProfileResponse: {
    fields: {
      player: {
        type: "Player",
        id: 1
      },
      currentMatch: {
        type: "Match",
        id: 2
      },
      scoreItem: {
        rule: "repeated",
        type: "ScoringItem",
        id: 3
      },
      previousMatch: {
        rule: "repeated",
        type: "Performance",
        id: 7
      },
      totalScore: {
        type: "int32",
        id: 8
      },
      matchRank: {
        type: "int32",
        id: 10
      },
      owner: {
        type: "User",
        id: 11
      },
      teamTimeline: {
        rule: "repeated",
        type: "TimelinePoint",
        id: 12
      },
      globalTimeline: {
        rule: "repeated",
        type: "TimelinePoint",
        id: 13
      },
      liveIndex: {
        type: "int32",
        id: 14
      }
    },
    reserved: [
      [
        5,
        5
      ],
      [
        6,
        6
      ],
      [
        9,
        9
      ],
      [
        4,
        4
      ]
    ],
    nested: {
      Performance: {
        fields: {
          match: {
            type: "Match",
            id: 1
          },
          score: {
            type: "int32",
            id: 2
          },
          team: {
            type: "Team",
            id: 3
          },
          minutesPlayed: {
            type: "int32",
            id: 4
          }
        }
      },
      TimelinePoint: {
        fields: {
          xIndex: {
            type: "int32",
            id: 1
          },
          xLabel: {
            type: "string",
            id: 2
          },
          yScore: {
            type: "int32",
            id: 3
          },
          event: {
            rule: "repeated",
            type: "TimelineEvent",
            id: 4
          },
          projection: {
            type: "bool",
            id: 5
          },
          notInTeam: {
            type: "bool",
            id: 6
          }
        }
      },
      TimelineEvent: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          clock: {
            type: "Clock",
            id: 2
          },
          value: {
            type: "int32",
            id: 3
          },
          event: {
            type: "MatchEvent",
            id: 4
          },
          bonus: {
            type: "BonusScoreType",
            id: 5
          },
          teamSubIn: {
            type: "bool",
            id: 6
          },
          teamSubOut: {
            type: "bool",
            id: 7
          },
          shortTitle: {
            type: "string",
            id: 9
          },
          subtitle: {
            type: "string",
            id: 10
          }
        }
      }
    }
  },
  PlayersResponse: {
    fields: {
      player: {
        rule: "repeated",
        type: "Player",
        id: 1
      },
      topWindow: {
        type: "int32",
        id: 2
      },
      original: {
        type: "Player",
        id: 3
      }
    }
  },
  ReferralsResponse: {
    fields: {
      bonus: {
        rule: "repeated",
        type: "ReferralBonus",
        id: 1
      },
      referredUsers: {
        type: "int32",
        id: 2
      },
      receivedBonus: {
        type: "Money",
        id: 3
      },
      outstandingBonus: {
        type: "Money",
        id: 4
      }
    }
  },
  RulesResponse: {
    fields: {
      version: {
        type: "int32",
        id: 1
      },
      scoringItem: {
        rule: "repeated",
        type: "RuleItem",
        id: 2
      },
      teamSize: {
        type: "int32",
        id: 3
      },
      playerValue: {
        rule: "repeated",
        type: "int32",
        id: 4
      },
      budget: {
        type: "int32",
        id: 5
      },
      minEntryFee: {
        type: "int32",
        id: 6
      },
      maxEntryFee: {
        type: "int32",
        id: 7
      },
      startingCoints: {
        type: "int32",
        id: 8
      },
      teamBonusPeriod: {
        type: "int32",
        id: 9
      },
      cleanSheetPeriod: {
        type: "int32",
        id: 10
      },
      cleanSheetMinPlayed: {
        type: "int32",
        id: 11
      },
      gameSize: {
        type: "int32",
        id: 12
      },
      prizeDistribution: {
        rule: "repeated",
        type: "int32",
        id: 13
      },
      rakePercentage: {
        type: "int32",
        id: 14
      }
    }
  },
  SaveDeviceResponse: {
    fields: {
      result: {
        type: "Result",
        id: 1
      }
    },
    nested: {
      Result: {
        values: {
          SDR_UNKNOWN_ERROR: 0,
          SDR_SUCCESS: 1
        }
      }
    }
  },
  SaveNotificationSettingsResponse: {
    fields: {
      result: {
        type: "Result",
        id: 1
      },
      newState: {
        type: "NotificationSettingsResponse",
        id: 2
      }
    },
    nested: {
      Result: {
        values: {
          ERROR_UNKNOWN: 0,
          SUCCESS: 1
        }
      }
    }
  },
  SaveTeamResponse: {
    fields: {
      result: {
        type: "Result",
        id: 1
      }
    },
    reserved: [
      [
        2,
        2
      ]
    ],
    nested: {
      Result: {
        values: {
          STR_UNKNOWN_ERROR: 0,
          STR_SUCCESS: 1,
          STR_INVALID_PLAYER_ID: 2,
          XXX_INSUFFICIENT_SUBS: 3,
          STR_INSUFFICIENT_BUDGET: 4,
          STR_MATCH_EXPIRED: 5,
          STR_SAVE_UNAVAILABLE: 6,
          STR_GOALKEEPER_LIMIT_EXCEEDED: 7
        }
      }
    }
  },
  SendMessageResponse: {
    fields: {
      result: {
        type: "Result",
        id: 1
      },
      remoteMessageId: {
        type: "string",
        id: 2
      },
      processedMessage: {
        type: "string",
        id: 3
      }
    },
    nested: {
      Result: {
        values: {
          ERROR_UNKNOWN: 0,
          SUCCESS: 1
        }
      }
    }
  },
  ShareGameResponse: {
    fields: {
      result: {
        type: "Result",
        id: 1
      },
      imageUrl: {
        type: "string",
        id: 2
      }
    },
    nested: {
      Result: {
        values: {
          SGR_UNKNOWN_ERROR: 0,
          SGR_SUCCESS: 1
        }
      }
    }
  },
  StoreProductsResponse: {
    fields: {
      coin: {
        rule: "repeated",
        type: "StoreProduct",
        id: 1
      },
      autosub: {
        rule: "repeated",
        type: "StoreProduct",
        id: 2
      },
      premium: {
        rule: "repeated",
        type: "StorePremiumProduct",
        id: 3
      }
    }
  },
  UserInfoResponse: {
    fields: {
      user: {
        type: "User",
        id: 1
      },
      gamesTotal: {
        type: "int32",
        id: 2
      },
      gamesWon: {
        type: "int32",
        id: 3
      },
      prizeTotal: {
        rule: "repeated",
        type: "Money",
        id: 4
      },
      bonusRemainingSec: {
        type: "int32",
        id: 6
      },
      bonusPeriodSec: {
        type: "int32",
        id: 7
      },
      bonusValue: {
        type: "Money",
        id: 8
      },
      linksTotal: {
        type: "int32",
        id: 9
      },
      lastLogin: {
        type: "int64",
        id: 10
      },
      favoriteTeam: {
        type: "Team",
        id: 11
      },
      favoritePlayer: {
        type: "Player",
        id: 12
      },
      topTeamScore: {
        type: "TopScore",
        id: 13
      },
      topPlayerScore: {
        type: "TopScore",
        id: 14
      },
      requestsTotal: {
        type: "int32",
        id: 15,
        options: {
          deprecated: true
        }
      },
      favoriteTeamJersey: {
        type: "Jersey",
        id: 16,
        options: {
          deprecated: true
        }
      },
      shareUrl: {
        type: "string",
        id: 17
      },
      achievement: {
        rule: "repeated",
        type: "Achievement",
        id: 18
      },
      achievementsUnlocked: {
        type: "int32",
        id: 19
      },
      achievementsTotal: {
        type: "int32",
        id: 20
      },
      latestAchievement: {
        type: "Achievement",
        id: 21
      },
      autosubCount: {
        type: "int32",
        id: 22
      },
      enhancedAutofill: {
        type: "bool",
        id: 23
      },
      autosubIntroAcked: {
        type: "bool",
        id: 24
      },
      activePremium: {
        type: "StorePremiumProduct",
        id: 25
      },
      disableAds: {
        type: "bool",
        id: 26
      },
      marketing: {
        type: "bool",
        id: 27
      },
      quizIntroAcked: {
        type: "bool",
        id: 28
      },
      promotionalMessage: {
        rule: "repeated",
        type: "PromotionalMessage",
        id: 29
      },
      counters: {
        type: "Counters",
        id: 30
      }
    },
    reserved: [
      [
        5,
        5
      ]
    ],
    nested: {
      TopScore: {
        fields: {
          match: {
            type: "Match",
            id: 1
          },
          player: {
            type: "Player",
            id: 2
          },
          score: {
            type: "int32",
            id: 3
          }
        }
      },
      PromotionalMessage: {
        fields: {
          promoId: {
            type: "string",
            id: 1
          },
          promoMessage: {
            type: "string",
            id: 2
          },
          promoCta: {
            type: "string",
            id: 3
          },
          highlighted: {
            type: "bool",
            id: 4
          }
        }
      },
      Counters: {
        fields: {
          pendingGameInvites: {
            type: "int32",
            id: 1
          },
          unseenFinishedGames: {
            type: "int32",
            id: 2
          },
          liveContests: {
            type: "int32",
            id: 3
          },
          pendingFinishedContests: {
            type: "int32",
            id: 4
          },
          pendingFriendRequests: {
            type: "int32",
            id: 5
          },
          storeOffers: {
            type: "int32",
            id: 6
          }
        }
      }
    }
  },
  UserListResponse: {
    fields: {
      user: {
        rule: "repeated",
        type: "User",
        id: 1
      },
      cursor: {
        type: "string",
        id: 2
      }
    }
  }
});

module.exports = $root;
